import script from "./LocalizacaoInput.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalizacaoInput.vue?vue&type=script&setup=true&lang=js"

import "./LocalizacaoInput.vue?vue&type=style&index=0&id=e4432c64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4432c64"]])

export default __exports__